<skitbs-template [title]="v('menu_terminate')">
    <div *ngIf="isContractTerminated == null" class="terminationPage">
        <div>
            <h2>Kündigung des Verpflegungsauftrages und des damit verbundene SEPA-Lastschriftmandates.</h2>
        </div>
        <div>
            <p>Hier können Sie Ihren Verpflegungsauftrag bequem online kündigen.</p>
            <div class="terminationInfo">
                <p style="font-weight: bold;">An welchem Tag soll das letzte Mal eine
                    Verpflegung erfolgen ? </p>
                <p-calendar id="date" #dates [(ngModel)]="calendarDate" [minDate]="getToday()" placeholder="dd.MM.yyyy"
                    dateFormat="dd.mm.yy" [required]="true"></p-calendar>
                <p style="font-weight: bold;">Für eventuelle Rückzahlungen prüfen Sie bitte die vorhandene
                    Bankverbindung bzw. geben Sie
                    eine neue Bankverbindung für die Rückzahlung an </p>
                <div class="p-input-filled">
                    <input pInputText [(ngModel)]="ibanNR" name="ibanNR" #_ibanNr="ngModel"
                        [ngModelOptions]="{updateOn: 'blur'}" (ngModelChange)="onIbanChanged(_ibanNr)"
                        style="width: 185px;" (focus)="onIbanFocus(_ibanNr)" (focusout)="onIbanFocusOut(_ibanNr)">
                    <br />
                    <div *ngIf="_ibanNr?.errors?.['ibanValidatorMessage'] && ibanNR" class="Red">
                        {{v('invalidIBAN')}}
                    </div>
                </div>
            </div>
            <div>
                <p>Der Vertrag endet zum Monatsende des angegebenen Datums und das SEPA-Lastschriftmandat endet
                    automatisch mit Abbuchung der letzten Rechnung im Folgemonat, spätestens am 15. des Folgemonats des
                    ausgewählten Kündigungsmonats.</p>
                <p>Hinweis: Alle Bestellungen nach dem ausgewählten Datum werden nach dem Absenden der Kündigung
                    sofort gelöscht, um weitere Kosten für Sie zu vermeiden.
                    Ihr Kundenkonto im Internet-Bestellsystem wird am 15. Des Folgemonats des ausgewählten
                    Kündigungsmonats geschlossen - bitte laden Sie sich bis dahin ggf. Ihre letzten Rechnungen herunter!
                </p>
                <p>Wenn eine Sicherheitsleistung gezahlt wurde:</p>
                <p>Ihre Sicherheitsleistung werden wir 8 Wochen nach dem Erlöschen des SEPA-Lastschriftmandats
                    (Rückbuchungsfrist) auf das uns bekannte Konto überweisen.</p>
                <p>Eine Kündigungsbestätigung erhalten Sie per E-Mail beziehungsweise als Nachricht im Bestellsystem
                    wenn wir keinen E-Mailadresse von Ihnen haben.
                </p>
                <p>Freundliche Grüße</p>
                <p>Ihr Kundencenter</p>
            </div>
            <div>
                <div class="TexAlCenter">
                    <button pButton label="{{v('menu_terminate')}}" (click)="setTerminationRequest()"
                        class="BsWid200p PadWithBorder10" iconPos="left" [disabled]="!canTerminate() || _ibanNr?.errors?.['ibanValidatorMessage']"></button>
                </div>
            </div>
            <div class="EmptyBox40"></div>
        </div>
    </div>
    <div *ngIf="isContractTerminated != null" class="terminationSentPage">
        <div>
            <p>Ihr Antrag zur Kündigung liegt uns bereits vor, wir bearbeiten ihn so schnell wie möglich. Wenn Sie Ihre
                Kündigung zurückziehen möchten, schreiben Sie bitte unter Angabe Ihrer Kundennummer an <span
                    style="font-weight: bold;">{{'TENANT_SVC_EMAIL'| env}}</span></p>
        </div>
    </div>
</skitbs-template>
